import React from 'react';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';

import styles from './HalfCardFeedBackHeader.pcss';
import properties from '../../../../modules/ajio-util/properties';
import { FLEEK_STORE_NAME } from '../../../../fleek/utils/constants';
import { getCurrentStore } from '../../../selectors/metaData';

const imageBaseRef = properties.getProperty('imageBaseUrl') + '/static/img/';

const cx = classNames.bind(styles);

interface HalfCardHeaderProps {
  brandName?: string;
  productName?: string;
  feebackCard?: boolean;
  variant: 'desktop' | 'mobile';
  pendingFeedBacksIsEmpty: boolean;
  currentStore?: string;
}

const HalfCardHeader = ({
  feebackCard = false,
  brandName = '',
  productName = '',
  variant = 'mobile',
  pendingFeedBacksIsEmpty = false,
  currentStore = ''
}: HalfCardHeaderProps) => {
  const isMobile = variant === 'mobile';
  const isFleek = currentStore === FLEEK_STORE_NAME;
  if (feebackCard) {
    return (
      <div
        className={cx(
          `${
            isMobile
              ? pendingFeedBacksIsEmpty
                ? 'empty-pending-feedbacks-mobile'
                : 'half-card-feeback-header-mobile'
              : pendingFeedBacksIsEmpty
              ? 'empty-pending-feedbacks-desktop'
              : 'half-card-feeback-header-desktop'
          }`,
          // NOTE: check isFleek condition in below code
          isMobile && isFleek ? 'fleek_review_submitted' : ''
        )}
        ref={(ele)=>{
          if(!ele) return

          ele.parentElement.style.maxHeight = "90dvh"
          ele.parentElement.parentElement.style.overflowY = "auto"
        }}
      >
        <div className={cx('confirm-icon-container')}>
          <img
            className={cx('imageIcon')}
            src={imageBaseRef + 'confirm-rating.svg'}
            alt="Tick icon"
            aria-hidden="true"
          />
        </div>
        <p role="heading" aria-level={2} className={cx('feedback-header')} aria-live='assertive' aria-atomic="true">Feedback Submitted</p>
        <p className={cx('feedbak-sub-header')}>Thank you for taking out the time</p>
        {!isFleek && (
          <p className={cx('feedbak-sub-details')}>
            Your rating has been sent for moderation. It may take a while before it reflects on the
            product page
          </p>
        )}
      </div>
    );
  }

  return (
    <div
      className={cx(
        'half-card-header',
        currentStore === FLEEK_STORE_NAME && 'fleek-half-card-header'
      )}
    >
      <p className={cx('header-brand-name')}>{brandName}</p>
      <p className={cx('eader-product-name')} role='heading' aria-level={2}>{productName}</p>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    currentStore: getCurrentStore(state)
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(HalfCardHeader);
